import axios from 'axios';

export const downloadFileContent = async (url, httpRequest = axios) => {
  const config = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/pdf'
  };

  const resp = await httpRequest({
    url,
    method: 'GET',
    responseType: 'blob'
  })

  return window.URL.createObjectURL(resp.data)
}